export enum GenderTypeEnum {
  MALE = "Male",
  FEMALE = "Female",
  Others = "Others",
}

export enum MaritalStatusEnum {
  Single = "Single",
  Married = "Married",
  Divorced = "Divorced",
  Widowed = "Widowed",
}

export enum GovtIdProofEnum {
  Aadhar = "Aadhar",
  Pan = "PAN",
  Passport = "Passport",
  DrivingLicense = "Driving License",
  VoterId = "Voter Id",
}
